export enum EResponseWhatsapp {
    SUCCESS = "Sucesso ao enviar mensagem",
    FAILED = "Falha ao enviar mensagem"
}

export enum EResponseEmail {
    SUCCESS = "Sucesso ao enviar email",
    FAILED = "Falha ao enviar email"
}